import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts
import NonAuthLayout from "./components/NonAuthLayout";
import VerticalLayout from "./components/VerticalLayout/";

// Import scss
import "./assets/scss/theme.scss";

//Import css
import "./App.css";

//Fake backend
import { ThemeProvider } from "@mui/material";
import { createTheme } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Import the i18n configuration
import AppRoute from "./routes/route";
import Error404 from "./pages/Utility/Error404";
import { responsiveWidth } from "./store/actions";
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {};

	}

	componentDidMount() {
		window.addEventListener("unload", () => {
			localStorage.setItem("lastOpen", new Date());
		});

		const handleResize = () => {
			this.props.responsiveWidth(window.innerWidth); // Update state when window resizes
		};
		window.addEventListener("resize", handleResize);

		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://cdn.jsdelivr.net/npm/remixicon/fonts/remixicon.css';
		document.head.appendChild(link);

	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	render() {
		const Layout = VerticalLayout;
		const theme = createTheme({
			formlabel: {
				fontFamily: 'FunnelSans',
			},
			formControlLabel: {
				fontFamily: 'FunnelSans',
			},
			typography: {
				fontFamily: 'FunnelSans',
				fontSize: 12.26, //it is 14 when display
			},

		});

		const filteredRoutes = this.props.isDirectSeller ?
			authProtectedRoutes.filter((route) =>
				!route.path.includes('setting') && !route.path.includes('accessories') && !route.path.includes('credits') &&
				!route.path.includes('loan-calculator') && !route.path.includes('accessory')
			)
			: authProtectedRoutes;

		return (
			<React.Fragment>
				<ThemeProvider theme={theme}>
					<I18nextProvider i18n={i18n}>
						<Routes basename={"/"}>
							{publicRoutes.map((route, idx) => (
								<Route
									path={route.path}
									element={
										<NonAuthLayout>
											{route.component}
										</NonAuthLayout>
									}
									key={idx}
									exact={true}
								/>
							))}

							{filteredRoutes.map((route, idx) => (
								<Route
									key={idx}
									path={route.path}
									element={
										<AppRoute requiredPermission={route.requiredPermission}>
											<Layout>{route.component}</Layout>
										</AppRoute>
									}
								/>
							))}

							{/* Redirect to 404 page if route is not available */}
							<Route path="*" element={<Error404 />} />
						</Routes>
					</I18nextProvider>

				</ThemeProvider>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		layout: state.Layout,
		isDirectSeller: state.Login.verifyAdmin?.user?.data?.profile
			? !state.Login.verifyAdmin?.user?.data?.profile?.selected_dealer_id
			: false,
	};
};


export default connect(mapStateToProps, { responsiveWidth })(App);
